import React, {
  useState,
  useCallback,
} from 'react';
import PropTypes from 'prop-types';
import format from 'string-template';

import useComponentMounted from '../../../../../../../hooks/useComponentMounted';
import useToast from '../../../../../../hooks/useToast';
import RadioButtonGroup from '../../../../../../components/RadioButtonGroup';
import { SettingOption } from '../../utils';
import LoadingOverlay from '../../../../../../components/LoadingOverlay';

import {
  SettingContainer as Container,
  HeaderContainer,
  SettingsActionContainer,
  TitleContainer,
  Title,
  SubTitle,
  ActionLabel,
} from '../WorkoutNotification/styles';

const AssignmentNotificationSetting = ({
  isEnabled,
  onSave,
  texts,
}) => {
  const { showToast } = useToast();
  const isComponentMountedRef = useComponentMounted();
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = useCallback(async (value) => {
    setIsLoading(true);
    try {
      await onSave(value === SettingOption.ENABLED);
      showToast(texts.successMessage);
    } catch (error) {
      showToast(format(texts.errorMessage, { error: error.message }), { error: true });
    } finally {
      if (isComponentMountedRef.current) {
        setIsLoading(false);
      }
    }
  }, [onSave, showToast, texts, isComponentMountedRef]);

  return (
    <>
      <Container>
        <HeaderContainer>
          <TitleContainer>
            <Title>{texts.title}</Title>
            <SubTitle>{texts.description}</SubTitle>
          </TitleContainer>
        </HeaderContainer>
        <SettingsActionContainer>
          <ActionLabel>{texts.toggleLabel}</ActionLabel>
          <RadioButtonGroup
            options={[
              { label: texts.enabled, value: SettingOption.ENABLED },
              { label: texts.disabled, value: SettingOption.DISABLED },
            ]}
            selectedOption={isEnabled ? SettingOption.ENABLED : SettingOption.DISABLED}
            onOptionChange={handleChange}
          />
        </SettingsActionContainer>
      </Container>
      <LoadingOverlay isLoading={isLoading} />
    </>
  );
};

AssignmentNotificationSetting.propTypes = {
  isEnabled: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  texts: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    toggleLabel: PropTypes.string.isRequired,
    enabled: PropTypes.string.isRequired,
    disabled: PropTypes.string.isRequired,
    successMessage: PropTypes.string.isRequired,
    errorMessage: PropTypes.string.isRequired,
  }).isRequired,
};

export default AssignmentNotificationSetting;
